<div class="context-menu" *ngIf="menuItems.length > 0"
     dropdown>
  <div class="context-menu__toggle"
        data-testid="dropdown-menu-wrapper"
       dropdownToggle
       aria-controls="dropdown-basic">
    <div class="btn-group">

      <lds-icon identifier="button-basic"
                data-testid="context-menu-button"
                name="options"
                size="sm"
                appearance="inherit">
      </lds-icon>

    </div>

  </div>

  <!-- options -->
  <ul id="dropdown-basic"
      *dropdownMenu
      class="context-menu__list shadow-sm dropdown-menu dropdown-menu-right"
      role="menu"      
      aria-labelledby="button-basic">

    <!-- items -->
    <li class="context-menu__item"
        role="menuitem"
        (click)="itemClicked(item)"
        *ngFor="let item of menuItems">
      
      <!-- Item with tooltip -->
      <ng-container *ngIf="item.tooltip && item.disabled; else noTooltip">
        <lds-tooltip [message]="item.tooltip">
          <a class="dropdown-item" data-testid="context-menu-item"
             [ngClass]="{ 
               'dropdown-item--warning': item | displayWarning,
               'dropdown-item--disabled': item.disabled 
             }">
            {{ item.name }}
          </a>
        </lds-tooltip>
      </ng-container>

      <!-- Item without tooltip -->
      <ng-template #noTooltip>
        <a class="dropdown-item" data-testid="context-menu-item"
           [ngClass]="{ 
             'dropdown-item--warning': item | displayWarning,
             'dropdown-item--disabled': item.disabled 
           }">
          {{ item.name }}
        </a>
      </ng-template>
    </li>

  </ul>
</div>
